/**
 * Alif Installment Calculator - Kalles Theme Version
 * Updates the installment price display based on cart total
 * 
 * Pre-configured for Kalles theme (v4.3.7)
 * Cart selector: .t4s-cart__totalPrice
 * Works with both cart page and cart drawer
 */

// Store last calculated prices to prevent unnecessary updates
let lastCalculatedPrices = new Map();
let updateTimer = null;
let isUpdating = false;

function calculateInstallment() {
  // Prevent multiple simultaneous updates
  if (isUpdating) {
    return;
  }
  
  isUpdating = true;
  // Kalles theme cart total selector - find all instances (cart page and drawer)
  const cartSubtotalDivs = document.querySelectorAll(".t4s-cart__totalPrice");
  
  // Process each cart total found (handles both cart page and drawer)
  cartSubtotalDivs.forEach(function(cartSubtotalDiv) {
    const cartTotalText = cartSubtotalDiv.textContent;
    
    if (cartTotalText) {
      // Clean the cart total text - remove all non-numeric characters except decimal point
      const cleanedCartTotalText = cartTotalText
        .replace(/[^0-9.]/g, "")
        .replace(/^\.+/, "");
      
      const cartPageTotal = parseFloat(cleanedCartTotalText);
      
      // Validate the parsed number
      if (!isNaN(cartPageTotal) && cartPageTotal > 0) {
        // Calculate the final cart price (divide by 3 for installment)
        const finalCartPrice = Math.floor(cartPageTotal / 3);
        const currency = sessionStorage.getItem("currency") || "";
        const newPriceText = currency + finalCartPrice.toLocaleString();
        
        // Find the closest installment widget to this cart total
        const cartContainer = cartSubtotalDiv.closest('.t4s-cartPage__footer, .t4s-mini_cart__footer, .t4s-cart-drawer, [data-cart-wrapper]');
        
        if (cartContainer) {
          // Find installment price div within the same cart container
          const priceDiv = cartContainer.querySelector(".alif-price-divide");
          
          if (priceDiv) {
            // Only update if the price has actually changed
            const priceDivId = priceDiv.getAttribute('data-price-id') || 
                              (cartContainer.id || Math.random().toString(36));
            
            // Store ID for future reference
            if (!priceDiv.getAttribute('data-price-id')) {
              priceDiv.setAttribute('data-price-id', priceDivId);
            }
            
            const lastPrice = lastCalculatedPrices.get(priceDivId);
            
            // Only update if price text is different
            if (lastPrice !== newPriceText && priceDiv.textContent !== newPriceText) {
              priceDiv.textContent = newPriceText;
              lastCalculatedPrices.set(priceDivId, newPriceText);
            }
          }
        } else {
          // Fallback: update all installment price divs if container not found
          const priceDivs = document.querySelectorAll(".alif-price-divide");
          priceDivs.forEach(function(priceDiv) {
            const priceDivId = priceDiv.getAttribute('data-price-id') || Math.random().toString(36);
            if (!priceDiv.getAttribute('data-price-id')) {
              priceDiv.setAttribute('data-price-id', priceDivId);
            }
            
            const lastPrice = lastCalculatedPrices.get(priceDivId);
            
            // Only update if price text is different
            if (lastPrice !== newPriceText && priceDiv.textContent !== newPriceText) {
              priceDiv.textContent = newPriceText;
              lastCalculatedPrices.set(priceDivId, newPriceText);
            }
          });
        }
      }
    }
  });
  
  isUpdating = false;
  
  // Clear any existing timer
  if (updateTimer) {
    clearTimeout(updateTimer);
  }
  
  // Call the function again after 1 second to update dynamically
  updateTimer = setTimeout(calculateInstallment, 1000);
}

// Wait for DOM to be ready before initializing
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', calculateInstallment);
} else {
  // DOM is already ready
  calculateInstallment();
}

// Listen for cart updates (for AJAX cart updates in drawer)
document.addEventListener('cart:updated', function() {
  setTimeout(calculateInstallment, 100);
});

// Listen for custom cart events that Kalles theme might trigger
document.addEventListener('t4s:cart:updated', function() {
  setTimeout(calculateInstallment, 100);
});

// MutationObserver to watch for cart drawer changes
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const target = mutation.target;
        if (target.classList && (
          target.classList.contains('t4s-cart__totalPrice') ||
          target.closest('.t4s-cartPage__footer, .t4s-mini_cart__footer, .t4s-cart-drawer')
        )) {
          shouldUpdate = true;
        }
      }
    });
    if (shouldUpdate) {
      setTimeout(calculateInstallment, 100);
    }
  });
  
  // Start observing when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      const cartContainer = document.querySelector('.t4s-cartPage__footer, .t4s-mini_cart__footer, .t4s-cart-drawer, [data-cart-wrapper]');
      if (cartContainer) {
        observer.observe(cartContainer, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    });
  } else {
    const cartContainer = document.querySelector('.t4s-cartPage__footer, .t4s-mini_cart__footer, .t4s-cart-drawer, [data-cart-wrapper]');
    if (cartContainer) {
      observer.observe(cartContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }
}

